import {  getDocumentAccess,  getRowsToDelete } from "../../helpers/helper";
import { DELETE, GET, PATCH, POST, PUT } from "../../service/axiosMethods";
import { ELASTIC_URL,  SHEETDATA_URL } from "../../utils/apiConstant";
import ACTION_TYPES from "../types";
import store from "../store";
import { makeSheetRowData, makeSheetRowDataWithPreDefinedRows } from "../../helpers/RowHelper";
import { JiraDataSourceHarvesting } from "../../helpers/MultiSourceHarvesting";
import { changeRecord } from "./jiraAction";
import { renderAlert } from "../../CommonComponents/Alert/Alert";
import { ifSheetDoesDeletedThenNavigate } from "../../pages/Sheet/helper/OptimizedSheetHelper";
import { updateSharedWbInStoreIfWbDeleted } from "./workbookAction";
import { updateSharedSheetInStore } from "./sheetAction";
import { trace } from "@opentelemetry/api";
import { deepCopy } from "../../MiniProducts/xTables/helper/helpersSubModule";
import { logSpan } from "../../helpers/loggingHelper";
import { sanitizeColumnDefs } from "../../MiniProducts/xTables/helper/helperFunctions";
import { mergeAzureBoard } from "../../containers/RightDrawer/helpers/azureWorkItemHelper";

const tracer = trace.getTracer('current-sheet-data-action');

export const EditSheetDocObj = (sheetRowCountInfo, sheetDocObj, sheet_identifier) => {
    if (sheetDocObj[sheet_identifier]) {
        sheetDocObj[sheet_identifier].forEach((sheet) => {
            if (sheetRowCountInfo)
                sheet.rowCount = sheetRowCountInfo[sheet.id]
        })

    }
    return sheetDocObj
}
 export function processAzureColumns(workItemsField, sheetColumns,newBoardIntegrated) {
    try {
     //   Get all Azure fields from API
      const azureFields = workItemsField?.data?.fields || []; // All possible Azure fields
  
      //  Divide into Azure columns and Normal columns
      const azureColumns = sheetColumns.filter((col) => col.azureColumn);
      const normalColumns = sheetColumns.filter((col) => !col.azureColumn);
  
  
      // Check which Azure fields are missing in sheet columns
      const sheetAzureNames = azureColumns.map((col) => col.azureColumn.toLowerCase());
      const missingAzureFields = azureFields.filter(
        (field) => !sheetAzureNames.includes(field.referenceName.toLowerCase())
      );
  
      return {
        azureColumns,
        normalColumns,
        missingAzureFields
      };
    } catch (error) {
      console.error("❌ Error processing Azure columns:", error);
      return { azureColumns: [], normalColumns: [], missingAzureFields: [] };
    }
  }

export async function refreshAzureData(
    columns, rows, currentSelectedSheet, currentSelectedWorkbook, userData, setAzureDataAfterRefresh, setIsUpdatingAzure
) {

    // let rows= JSON.parse(JSON.stringify(sheetData?.data?.Rows));
    // let columns= JSON.parse(JSON.stringify(sheetData.data.columns))
    if (!rows) {
        return [];
    }
    let sheetRowsWithoutAzureRows = rows.filter((row) => !row?.isAzureRow);
    
    let board = currentSelectedSheet?.azureIntegrationInfo ? JSON.parse(currentSelectedSheet.azureIntegrationInfo)?.name : ''
    if (board && currentSelectedSheet.sheetType !=="filterSheet") {

        const workItems = await POST("/azureauth/getWorkItemsForAProject", { project: board })
        const workItemsField = await GET(`/azureauth/fields?project=${board}`);

        let { azureColumns, normalColumns, missingAzureFields } = processAzureColumns(workItemsField, columns)
        // let insertRow= insertRowCallback(row, currentSelectedSheet.id, currentSelectedWorkbook.id, userData, callback)
        const { mergedRows, mergedColumns } = mergeAzureBoard(workItems.data.workItems, columns, { insertRow: (row, callback) => insertRowCallback(row, currentSelectedSheet?.id, currentSelectedWorkbook?.id, userData, callback) }, missingAzureFields);
        //   rows=[...mergedRows,...rows]

        // if (mergedRows?.length || mergedColumns?.length) 
        // setIsUpdatingAzure(true)

        setAzureDataAfterRefresh({ mergedColumns, mergedRows })

        return { mergedColumns, mergedRows }
    } else return []
}
export const getSheetDataRows = ({ sheet, selectedSheetId, currentSelectedSheet, currentSheetRows, currentSelectedWorkbook,
    navigate,
    selectSheet }, callback,callbackToSetColumns,setAzureDataAfterRefresh,azureDataAfterRefresh) => async (dispatch) => {
    try {
        let sheetId = sheet ? sheet.id : selectedSheetId;
        let {currentSelectedSheet , sheetListData} = store.getState().sheetReducer;

        let indexOfsheetInSheetList = sheetListData.findIndex((sheet)=>sheet.id === sheetId)
        // if(sheetListData[indexOfsheetInSheetList] && sheetListData[indexOfsheetInSheetList].columns) setRawColumns(sheetListData[indexOfsheetInSheetList].columns)
        // if(sheetListData[indexOfsheetInSheetList] && sheetListData[indexOfsheetInSheetList].Rows) {setRawData(sheetListData[indexOfsheetInSheetList].Rows);return}
        let { userData } = store.getState().userReducer
        let { sheetDocObj } = store.getState().sheetReducer
        if (sheetDocObj && Object.keys(sheetDocObj).length === 0) {
            let temporarySheet = { ...sheet }
            delete temporarySheet.Rows
            sheetDocObj[sheet.sheet_identifier] = [{ ...temporarySheet }]
        }
        if (currentSheetRows && currentSheetRows.length && currentSheetRows[0].sheet_id === sheetId) return;
        let response;
        if ((sheet && sheet.sheetType === "checkinagent") || currentSelectedSheet.sheetType === "checkinagent") {
            let referenceSheetId = sheet ? sheet.referenceSheetId : currentSelectedSheet.referenceSheetId
            let payload = { index: 'sheetrow', user_id: userData.email, sheet_id: sheet ? sheet.id : `${currentSelectedSheet.id}`, referenceSheetId: referenceSheetId,sheet_identifier: sheet?sheet.sheet_identifier:currentSelectedSheet.sheet_identifier}

            if (localStorage.getItem('mD_' + payload.sheet_id)) payload.metaData = localStorage.getItem('mD_' + payload.sheet_id)
            response = await POST(`${ELASTIC_URL}/sheetrow/getCheckinAgentSheet`, payload)
        }
        else {
            let payload = { index: 'sheetrow', user_id: userData.email, sheet_id: sheet ? sheet.id : `${currentSelectedSheet.id}` }

            if (localStorage.getItem('mD_' + payload.sheet_id)) payload.metaData = localStorage.getItem('mD_' + payload.sheet_id)
            response = await POST(`${ELASTIC_URL}/sheetrow/searchBySheetId`, payload)        
            if(response?.data?.updateddate) dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: response.data.updateddate })
            else {
                dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: '' })
                dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, createdDateOfSheet: response.data.createdDate })
            }
        }
        if (response.data === 'Sheet does not exist') {
            renderAlert('Sheet deleted by reciever', 'error')
            // setTimeout(window.location.reload(), 3000);if
        }
        if(response.data && response.data.deactivated){
            const deletedSheet = {
                id: sheet ? sheet.id : `${currentSelectedSheet.id}`
            }
            await dispatch(ifSheetDoesDeletedThenNavigate(deletedSheet, currentSelectedWorkbook, false, navigate,
              selectSheet));
            //   callback("", "","","", true)
            //   callbackToSetColumns("",true)
            return
        }
        if (response &&  response.data) {
            if (sheetListData[indexOfsheetInSheetList]) {
                sheetListData[indexOfsheetInSheetList].columns = response?.data?.columns;
              }
            // sheetListData[indexOfsheetInSheetList]?.columns = response?.data?.columns
            callbackToSetColumns(response.data.columns)
            let rawData //converting my elastic data to xTables rows format
            if (currentSelectedSheet?.sheetType === 'jira') {
                let { rows } = await JiraDataSourceHarvesting({ dbRows: response.data.Rows, jql: currentSelectedSheet.jql, selectedFields: currentSelectedSheet.selectedFields, columns: currentSelectedSheet.columns, dispatch })
                rawData = rows
                let newsheetDocObj = EditSheetDocObj(response.data.sheetRowCountInfo, sheetDocObj, currentSelectedSheet.sheet_identifier)
                dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetDocObj, sheetDocObj: newsheetDocObj })
            }
            else {

                rawData = response.data.Rows 
                let newsheetDocObj = EditSheetDocObj(response.data.sheetRowCountInfo, sheetDocObj, currentSelectedSheet.sheet_identifier)
                dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetDocObj, sheetDocObj: newsheetDocObj }); 
                if(response.data.namedFilters){
                    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, namedFilters : response.data.namedFilters  });
                }else{
                    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, namedFilters : []  });
                }
            }
            if (sheetListData[indexOfsheetInSheetList]) {
                sheetListData[indexOfsheetInSheetList].Rows = rawData
              }
            
            if (response.data?.lastUpdatedByUser && sheetListData[indexOfsheetInSheetList]) sheetListData[indexOfsheetInSheetList].lastUpdatedByUser = response.data.lastUpdatedByUser
            callback(rawData, response.data.locked, response.data.lastUpdatedByUser, response.data.xPadContent)
            dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false })
             let latestSheetListData = store.getState().sheetReducer.sheetListData;
            dispatch({
                type: ACTION_TYPES.SET_SHEET_DATA,
                sheetListData:latestSheetListData,
              });
            dispatch({ type: ACTION_TYPES.SET_UPDATED_TIME, updatedNotesTimeStamp: response?.data?.updatedNotesTimeStamp ||"" })

            return
        }
    } catch (error) {
        console.log("error in getting sheet data from API", error)
    }
}

export const updateRowCallback = ({ row, rowIndex, rowMetaData }) => async (dispatch) => {
    const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer
    let body = {
        "l_id": row.l_id.toString()
    }
    if (row.wrap) body.wrap = row.wrap
    body.sheet_id = currentSelectedSheet.id
    body.sheetDocObj = sheetDocObj[currentSelectedSheet.sheet_identifier]
    body.sheetIdToEdit = rowMetaData.sheet_id
    body.rowIndex = rowIndex
    const response = await PATCH(`${ELASTIC_URL}/sheetrow/update`, { index: 'sheetrow', doc: body, id: row.id })
}

export const updateRowStylesCallback = async ({ row, rowIndex, colId, selectedSheetId, rowMetaData }) => {
    try {
        const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer
        let data = {}
        if (row[colId]) {
            data = {
                "content": { format: row[colId].format || "", cellStyle: row[colId].cellStyle || {} },
                column: colId,
                "index": 'sheetrow',
                "sheetrowid": row.id,
                sheetIdToEdit: rowMetaData.sheet_id,
                sheet_id: selectedSheetId,
                sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier], rowIndex
            }
        }
        else data = {
            "column": colId,
            "index": "sheetrow",
            "sheetrowid": row.id,
            sheet_id: selectedSheetId,
            sheetIdToEdit: rowMetaData.sheet_id,
            sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier], rowIndex,
            "content": {
                "value": "",
                "format": row[colId].format,
                "cellStyle": row[colId].cellStyle,
                "notes": "",
                "attachments": []
            }

        }
        const response = await PATCH(`${ELASTIC_URL}/sheetrow/formatting`, data)

    } catch (error) {
        console.log(error)
    }
}

export const updateColDefsCallback = (col, newColDefs) => async (dispatch) => {
    try {
        let { currentSelectedSheet, sheetListData } = store.getState().sheetReducer
        col=deleteChildrenFromColumns([JSON.parse(JSON.stringify(col))])[0]
        let payload = { id: currentSelectedSheet.id, sheet_identifier: currentSelectedSheet.sheet_identifier, columnElasticid: col.columnElasticid, updatedColumn: col }
        if (localStorage.getItem('mD_' + currentSelectedSheet.id)) payload.metaData = localStorage.getItem('mD_' + currentSelectedSheet.id)
        await PATCH(`${ELASTIC_URL}/sheet/updateColumn`, payload)
        sheetListData.forEach((sheet) => {
            if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
        })
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetListData })
    } catch (error) {
        console.log(error)
    }
}
export const updateMultipleColumns = (cols, newColDefs) => async (dispatch) => {
    try {
        let { currentSelectedSheet, sheetListData } = store.getState().sheetReducer
        cols=deleteChildrenFromColumns(JSON.parse(JSON.stringify(cols)))
        let payloadColumns=cols.map((col)=>{
            return {
                columnElasticid:col.columnElasticid,
                updatedColumn: col
            }
        })
        let payload = { id: currentSelectedSheet.id, sheet_identifier: currentSelectedSheet.sheet_identifier, columns:payloadColumns }
        if (localStorage.getItem('mD_' + currentSelectedSheet.id)) payload.metaData = localStorage.getItem('mD_' + currentSelectedSheet.id)
        const response = await PATCH(`${ELASTIC_URL}/sheet/updateColumns`, payload)
        if(response?.data){
            dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: response?.data?.updatedDate || '' })
        }
        if(newColDefs){
            sheetListData.forEach((sheet) => {
                if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
            })
            dispatch({type: ACTION_TYPES.SET_SHEET_DATA, sheetListData })
        }
    } catch (error) {
        console.log(error)
    }
}

const removeFunctionsofColumnArray = (column) =>{
    try {
        let updateCol = {...column};
        if(Object.keys(updateCol).length > 0){
            for (let key in updateCol) {
                if (typeof updateCol[key] === 'function' || (key === 'cellRendererParams' || key === "headerComponentParams")) {
                  delete updateCol[key];
                }
              }
              return updateCol;
        }
        return column;
        
    } catch (error) {
        console.error("Error in removeFunctionsofColumnArray",error);
    }
}
export const updateColumnWithId = (column, newColDefs,NewOptionFromAddOption) => async (dispatch) => {
    try {
        let { currentSelectedSheet, sheetListData } = store.getState().sheetReducer;
        let updateCol = removeFunctionsofColumnArray(column);
        column = deleteChildrenFromColumns([JSON.parse(JSON.stringify(updateCol))])[0]
        let payload = { id: currentSelectedSheet.id, sheet_identifier: currentSelectedSheet.sheet_identifier, columnElasticid: column.columnElasticid, updatedColumn: column }
        if (localStorage.getItem('mD_' + currentSelectedSheet.id)) payload.metaData = localStorage.getItem('mD_' + currentSelectedSheet.id)
        let resp=await PATCH(`${ELASTIC_URL}/sheet/updateColumn`, payload)

        if(resp.status >= 200 && resp.status < 300){
            if(resp?.data){
                dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: resp?.data?.updatedDate })
            }
    
            if(newColDefs){
                sheetListData.forEach((sheet) => {
                    if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
                })
                dispatch({type: ACTION_TYPES.SET_SHEET_DATA, sheetListData })
            }
            
            if(NewOptionFromAddOption===false && newColDefs)
            {
                renderAlert("column updated","success")
            }
            return true;

     }
        console.error("Error in updateColumnWithId, response:", resp)
        renderAlert('Error in updating column', 'error')
        return false

    } catch (error) {
        
        console.error("Error in updateColumnWithId",error)
        renderAlert('Error in updating column', 'error')
        return false
    }
}

export const orderSheetColumnsFunc = (columnOrder,newColDefs)  => async (dispatch) => {
    try {
        if(!columnOrder || !columnOrder.length) return
        let { currentSelectedSheet, sheetListData } = store.getState().sheetReducer
        if(!currentSelectedSheet) return
        let payload = { id: currentSelectedSheet.id, sheet_identifier: currentSelectedSheet.sheet_identifier, order:columnOrder }
        if (localStorage.getItem('mD_' + currentSelectedSheet.id)) payload.metaData = localStorage.getItem('mD_' + currentSelectedSheet.id)
        POST(`${ELASTIC_URL}/sheet/orderSheetColumns`, payload)    
        if(newColDefs){
            sheetListData.forEach((sheet) => {
                if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
            })
            dispatch({type: ACTION_TYPES.SET_SHEET_DATA, sheetListData })
        }
           

    } catch (error) {        
        console.log(error)
    }
}
export const deleteChildrenFromColumns=(columns) => {
    let newColumns = columns.map((column) => {
        if (column.children) {
            delete column.children
            delete column.displayName
            delete column.groupId
            delete column.headerGroupComponentParams
            delete column.headerComponentParams
        }
        if(column?.type === 'multi dimensional value' && column['listData'] && Array.isArray(column['listData']))column["listData"] = JSON.stringify(column.listData)
        return column
    })
    return newColumns
}
export const addColumnToIndex = (selectedFirstColumnIndex, columnToInsert, selectedSheetId,  newColDefs,callback) => async (dispatch) => {
    try {
        let { currentSelectedSheet, sheetListData ,selectedSheetId} = store.getState().sheetReducer;
        columnToInsert= await deleteChildrenFromColumns(deepCopy(sanitizeColumnDefs(columnToInsert)))
        const sheetIndex = window.SHEET_INDEX;
        console.log('column to insert in the sheet',columnToInsert,selectedFirstColumnIndex)
        let payload = { 'id': currentSelectedSheet.id, index: sheetIndex, colIndex: selectedFirstColumnIndex, newColumn: columnToInsert }
        if (localStorage.getItem('mD_' + currentSelectedSheet.id)) payload.metaData = localStorage.getItem('mD_' + currentSelectedSheet.id)  
        const res=await PUT(`${ELASTIC_URL}/sheet/columnAtIndex`, payload)
        if(res.data){
            sheetListData.forEach((sheet) => {
                if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
            })
            if(sheetListData.length > 0 && selectedSheetId)
            dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetListData ,currentSelectedSheet:{...currentSelectedSheet,columns:newColDefs}})
            
            if(columnToInsert[0].field )renderAlert('Column inserted', 'success')
            else renderAlert("Group created",'success')
            if(callback) callback(true)
        }
        else {
            if(callback) callback(false)
            renderAlert('Error in inserting Column', 'error')
            return false;
        } 
        

    } catch (error) {
        console.log(error)
        renderAlert('Error in inserting Column', 'error')
        return false;
    }
}
export const deleteColumn = (col, newColDefs) => async (dispatch) => {
    try {
        let sheetid
        const { sheetDocObj, currentSelectedSheet, selectedSheetId, sheetListData } = store.getState().sheetReducer
        if (!sheetid) sheetid = selectedSheetId
        let payload = { id: sheetid, columnElasticid: col.colDef.columnElasticid, field: col.colDef.field, sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier] }
        if (localStorage.getItem('mD_' + sheetid)) payload.metaData = localStorage.getItem('mD_' + sheetid)
        await POST(`${ELASTIC_URL}/sheet/deleteColumn`, payload)
        sheetListData.forEach((sheet) => {
            if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
        })
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetListData })
        if(col.colDef?.field) renderAlert('Column deleted', 'success')
        else renderAlert('Group deleted','success')
    } catch (error) {
        console.log(error)
        renderAlert('Error in deleting Column', 'error')
    }
}
export const deleteMultipleColumns = (cols, newColDefs) => async (dispatch) => {
    try {
        let sheetid
        const { sheetDocObj, currentSelectedSheet, sheetListData } = store.getState().sheetReducer
        if (!sheetid) sheetid = currentSelectedSheet.id
        let payload = { id: sheetid, columnElasticIds:cols.map((col)=>col.colDef?.columnElasticid ?? col.columnElasticid) , sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier] }
        if (localStorage.getItem('mD_' + sheetid)) payload.metaData = localStorage.getItem('mD_' + sheetid)
        const response = await POST(`${ELASTIC_URL}/sheet/deleteMultipleColumns`, payload)
        if(response?.data){
            dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: response?.data?.updatedDate })
        }
        sheetListData.forEach((sheet) => {
            if (sheet.id === currentSelectedSheet.id) sheet.columns = newColDefs
        })
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetListData })
        if(cols[0]?.colDef?.block || cols[0].block) {
            renderAlert('Block deleted','success')
        }else if(cols[0]?.colDef.groupId){
            renderAlert('Group deleted','success')
        }else{
            renderAlert('Column(s) deleted','success')
        }
    } catch (error) {
        console.log(error)
        renderAlert('Error in deleting Column', 'error')
    }
}
export const deleteSheetData = (currentSheetRows, gridRef) => async (dispatch) => {
    try {
        let sheetDataIdList = getRowsToDelete(gridRef, currentSheetRows);
        if (sheetDataIdList && sheetDataIdList.size > 0) {
            let url = SHEETDATA_URL + "/delete";
            let body = JSON.stringify(Array.from(sheetDataIdList));
            let response = await DELETE(url)

        }

    } catch (error) {
        console.log(error)
    }
}

export const updateRowsDataInDB = ({ row, sheetId, workbookId, result }) => async (dispatch) => {
    try {
        let body = JSON.stringify({
            "row": JSON.stringify(row),
            "sheetid": sheetId,
            "workbookid": workbookId,
            "rowindex": result.rowindex,
            "parent_id": 0,
            "l_id": result.id.toString(),
        });
        const res = await PATCH(`${SHEETDATA_URL}/${result.id}`, body);
        // await dispatch(getSheetDataRows("",sheetId));
    } catch (error) {
        console.log("error in updating rows", error)
    }
}

export const updateNextNodeInDBCallback = async ({ rowToUpdate, next_node }) => {
    let { selectedSheetId, sheetDocObj } = store.getState().sheetReducer.selectedSheetId
    const res = await PATCH(`${ELASTIC_URL}/sheetrow/update`, { index: 'sheetrow', id: rowToUpdate, doc: { next_node: next_node }, sheet_id: selectedSheetId, sheetDocObj });
}
export const updatePrevNodeInDBCallback = async ({ rowToUpdate, prev_node }) => {
    let { selectedSheetId, sheetDocObj } = store.getState().sheetReducer.selectedSheetId
    const res = await PATCH(`${ELASTIC_URL}/sheetrow/update`, { index: 'sheetrow', id: rowToUpdate, doc: { prev_node: prev_node }, sheet_id: selectedSheetId, sheetDocObj });
}
export const insertRowCallback = async ( row, sheetId, workbookId, user,  callback) => {
    let body = {
        ...row,
        "sheet_id": sheetId,
        "user_id": user.user_id || user.email,
        "user_email": user.email,
        "workbookid": workbookId,
        "remote_datasource": "Elastic",
        "attachments": [

        ],
        "notes": "Notes example",
        "created_date": new Date().toISOString(),
        "updated_date": new Date().toISOString(),
    }
    callback(body)
}


export const cellValueChangedCallback = ({ newValue, rowIndex, sheetRowId, row, columnId, columnType, selectedSheetId, sheetType, typeSpecificData, rowMetaData, columns }) => async (dispatch) => {
    const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer
    if (sheetType === 'jira' && columnType === 'jira') {
        changeRecord({ id: typeSpecificData.issueId, value: newValue, field: typeSpecificData.field, columns, columnId })
    }
    // else{
    let data = {}
    if (row[columnId]) {
        data = {
            "content": { value: newValue },
            column: columnId,
            "sheet_id": selectedSheetId,
            "sheetIdToEdit": rowMetaData.sheet_id,
            "sheetrowid": sheetRowId,
            "index": 'sheetrow',
            sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier],
        }
    }
    else data = {
        "column": columnId,
        "index": "sheetrow",
        "sheetrowid": sheetRowId,
        "sheet_id": selectedSheetId,
        "sheetIdToEdit": rowMetaData.sheet_id,
        sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier],
        "content": {
            "value": newValue,
            "format": "",
            "notes": "",
            "attachments": []
        }

    }
    const response = await PATCH(`${ELASTIC_URL}/sheetrow/formatting`, data)
    // }   

}
export const placeMultipleCallsForCellEdit = ({ editedRowsArray, selectedSheetId, selectSheet, selectedCellAfterRefresh, callback }) => async (dispatch) => {
    if (selectedCellAfterRefresh) renderAlert('Saving your content', 'success', 'center', '2000')
    const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer
    let rowsArray = []
    let refreshed = false
    editedRowsArray.forEach((row, index) => {

        if (row.sheetRowId) {
            rowsArray.push({
                content: { value: row.newValue },
                column: row.columnId,
                "sheet_id": row.rowMetaData.sheet_id,
                "sheetrowid": row.sheetRowId,
            })
        }
        else rowsArray.push({
            content: { l_id: row.row.l_id },
            column: '',
            "sheet_id": row.rowMetaData.sheet_id,
            "sheetrowid": row.row.id,
        })

    })
    let data = {
        "rowsArray": rowsArray,
        "sheet_id": selectedSheetId,
        sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier],
    }
    if (!refreshed)
        await PATCH(`${ELASTIC_URL}/sheetrow/formattingMultipleRows`, data)
    if (selectedCellAfterRefresh) {
        let temporarySheet = { ...currentSelectedSheet }
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: null })
        setTimeout(async () => {
            // selectSheet(temporarySheet)
            callback(temporarySheet)
        }, 2000);
        return
    }

}
export const checkIfRowIsAParent = ({ gridRef, }) => async (dispatch) => {
    let currentSheetRows = gridRef.current.props.rowData;
    let selectedNodes = gridRef.current.api.getSelectedNodes()
    if (selectedNodes.length == 0) {
        let cell = gridRef.current.api.getFocusedCell()
        selectedNodes = [currentSheetRows[cell.rowIndex]]
    }
    let children = await POST(`${ELASTIC_URL}/sheetrow/findChilds`, { id: selectedNodes[0].id })
    if (children.data.length && children.data.length > 1) {
        return children.data
    }
    else return false
}

export const deleteRowCallback = async ({ selectedSheetId, deleteIndex, rowMetaData, dispatch }) => {
    const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer
    const sheetIndex = window.SHEET_INDEX;

    const res = await POST(`${ELASTIC_URL}/sheetrow/delete`, { index: sheetIndex, sheet_id: selectedSheetId, sheetIdForDelete: rowMetaData.sheet_id, deleteIndex, sheet_identifier: currentSelectedSheet.sheet_identifier, sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier] })
    if (sheetDocObj[currentSelectedSheet.sheet_identifier]) {
        let temp = sheetDocObj[currentSelectedSheet.sheet_identifier]
        temp.forEach((sheet) => {
            if (sheet.id === rowMetaData.sheet_id) sheet.rowCount > 0 ? sheet.rowCount-- : sheet.rowCount = 0
        })
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetDocObj: sheetDocObj })
    }
}

export const deleteRowWithItsChildCallback = async (ids, metaData, order) => {
    const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer
    
    const res = await POST(`${ELASTIC_URL}/sheetrow/bulkDelete`, { index: 'sheetrow', ids: ids, metaData, order, sheet_id: currentSelectedSheet.id, sheetDocObj: sheetDocObj[currentSelectedSheet.sheet_identifier] })

}

export const updateDefaultGridSort = ({ sort }) => {
    let sheet_id = store.getState().sheetReducer.selectedSheetId
    
    POST(`${ELASTIC_URL}/sheetrow/gridSort`, { sort, sheet_id })
}

export const InsertInitialRowsInDB = ({ selectedSheetId, selectedWorkbookId, userData, uuid, setRawData, rows, sheetType, newCols }) => async (dispatch) => {
    try {
        const sheetId = selectedSheetId;
        const workbookId = selectedWorkbookId || store.getState().workbookReducer.selectedWorkbookId;
        const rowData = rows ? makeSheetRowDataWithPreDefinedRows({ sheetId: selectedSheetId, user_id: userData.user_id || userData.email, user_email: userData.email, uuid, workbook_id: workbookId, rows, sheetType, newCols }) : makeSheetRowData({ sheetId: selectedSheetId, user_id: userData.user_id || userData.email, user_email: userData.email, uuid, workbook_id: workbookId })
        const response = await POST(`${ELASTIC_URL}/sheetrow/insertInitialRows`, rowData);
        let result = response?.data?.docs?.items;
        const sheetRowData = response?.data?.insertedDataWithId;
        let rowsObject = {};
        // result.sort((a, b) => a.rowindex - b.rowindex);
        sheetRowData && sheetRowData.length && sheetRowData.forEach((item, index) => {
            let obj = { l_id: item.id.toString(), id: item.id };

            rowsObject[item.id] = obj
        })
        setRawData(sheetRowData)
        await dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, currentSheetRows: sheetRowData, currentRowsObject: rowsObject })
        return;
    } catch (error) {
        console.log("error in inserting initial rows in DB", error);
    }
}


export const moveColumns = (column, currentIndex, newIndex, newColDefs,clickSave) => async (dispatch) => {
    try {
        let { currentSelectedSheet, sheetListData } = store.getState().sheetReducer
        column=deleteChildrenFromColumns([JSON.parse(JSON.stringify(column))])[0]
        let currentIndexUpdated
        currentSelectedSheet.columns.forEach((col, index) => { if (col.columnElasticid === column.columnElasticid) currentIndexUpdated = index; })
        const sheetIndex = window.SHEET_INDEX;
        let data = { sheetid: currentSelectedSheet.id, index: sheetIndex, columnMovedElasticColId: column.columnElasticid, currentIndex: currentIndexUpdated, newPositionNodeColumnElasticid: newIndex.columnElasticid  }
        if (localStorage.getItem('mD_' + currentSelectedSheet.id)) data.metaData = localStorage.getItem('mD_' + currentSelectedSheet.id)
        if(clickSave) clickSave()
        const response = await PATCH(`${ELASTIC_URL}/sheet/moveColumn`, data)
        if(response?.data){
            dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: response?.data?.updatedDate })
        }
        // updated sheetList updated_data
        sheetListData.forEach((sheet) => {
            if (sheet.id === currentSelectedSheet.id) {
                sheet.updated_date =response?.data?.updatedDate; 
                sheet.columns = newColDefs}

        })
 
          dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetListData: sheetListData });
    }
    catch (error) {
        console.log("Error in Redo Stack", error)
    }
}
export const undoEditChanges = ({ currentSheetRows, row, gridRef }) => async (dispatch) => {
    const undoStack = store.getState().currentSheetDataReducer.undoStack;
    let data = currentSheetRows
    data.splice(row.index, 1, row.rowData)
    gridRef.current.api.applyTransaction({
        update: [row.rowData],
    });
    let body = {
        "content": { value: row.value },
        column: row.column,
        "sheetrowid": row.sheetrowid,
        "index": 'sheetrow'
    }
    await PATCH(`${ELASTIC_URL}/sheetrow/formatting`, body)
    let newUndoStack = undoStack
    newUndoStack = newUndoStack.slice(1)
    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, undoStack: newUndoStack })
}
export const undoStyleChanges = ({ currentSheetRows, row, gridRef }) => async (dispatch) => {
    const undoStack = store.getState().currentSheetDataReducer.undoStack;
    let data = currentSheetRows
    data.splice(row.index, 1, row.rowData)
    gridRef.current.api.applyTransaction({
        remove: [row.rowData],
    });
    gridRef.current.api.applyTransaction({
        add: [row.rowData],
        addIndex: row.index,
    });
    let body = {
        "content": { cellStyle: row.cellStyle, format: row.format },
        column: row.column,
        "sheetrowid": row.sheetrowid,
        "index": 'sheetrow'
    }
    await PATCH(`${ELASTIC_URL}/sheetrow/formatting`, body)
    let newUndoStack = undoStack
    newUndoStack = newUndoStack.slice(1)
    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, undoStack: newUndoStack })
}

export const undoDeleteRow = ({ row, gridRef }) => async (dispatch) => {
    const undoStack = store.getState().currentSheetDataReducer.undoStack;
    let { currentRowsObject, currentSheetRows } = store.getState().currentSheetDataReducer;
    let data = currentSheetRows
    data.splice(row.index, 0, row.rowData)
    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, currentSheetRows: data })
    gridRef.current.api.applyTransaction({
        add: [row.rowData],
        addIndex: row.index,
    });
    const sheetId = store.getState().sheetReducer.selectedSheetId;
    const workbookId = store.getState().workbookReducer.selectedWorkbookId;
    let user = store.getState().userReducer.userData

    let body = row.rowData
    delete body.id
    let res = await PATCH(`${ELASTIC_URL}/sheetrow/insertSheetRow`, { index: 'sheetrow', body: body })
    if (res.data) {
        let id = res.data._id
        if (row.rowData.next_node) {

            await dispatch(updatePrevNodeInDB({ prevNode: id, updatingId: row.rowData.next_node, rowsObject: currentRowsObject, sheetId, workbookId }))
        }
        if (row.rowData.prev_node) {
            await dispatch(updateNextNodeInDB({ nextNode: id, updatingId: row.rowData.prev_node, rowsObject: currentRowsObject, sheetId, workbookId }))
        }
    }

    let newUndoStack = undoStack
    newUndoStack = newUndoStack.slice(1)
    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, undoStack: newUndoStack })
}

export const undoColumnDelete = ({ row, selectedSheetId }) => async (dispatch) => {
    let { currentSheetColumnDefs, undoStack } = store.getState().currentSheetDataReducer
    let newColDefs = currentSheetColumnDefs
    newColDefs.splice(row.index, 0, row.column)
    await dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, currentSheetColumnDefs: [] })
    dispatch(addColumnToIndex(row.index + 1, row.column, selectedSheetId))
    let newUndoStack = undoStack
    newUndoStack = newUndoStack.slice(1)
    await dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, undoStack: newUndoStack, currentSheetColumnDefs: newColDefs })
}
export const removeAttachmentsFromRow = (file, sheet, selectedRow) => async (dispatch) => {
    try {
        // let updatedAttachaments=selectedRow.data.attachments?.filter((att)=>att.url!==file.url) ??[]
        const response = await POST(`${ELASTIC_URL}/sheetrow/remove/removeAttachmentFromRow`, { sheetId: sheet.id, sheetrowid: selectedRow.key, file: file.url });
        return response

    } catch (error) {
        console.log("error in deleting sheet", error);
    }
}
export function isThereDataToBeSaved (gridChangesPerSaveSession){
    if (gridChangesPerSaveSession) {
        const { add, update, delete: del } = gridChangesPerSaveSession;
        if (Object.keys(add).length === 0 && Object.keys(update).length === 0 && Object.keys(del).length === 0) {
            return false; // Return from the function if no changes
        }
        return true
    }
    return true;
}

export const checkAccessOfTheDocument =  (navigate) => async(dispatch) => {
    try {
        const { currentSelectedSheet, isShared } = store.getState().sheetReducer;
        const { userData } = store.getState().userReducer;
        const { isSharedWorkbook, currentSelectedWorkbook } = store.getState().workbookReducer;
        if (isSharedWorkbook) {
            const access = await getDocumentAccess(currentSelectedWorkbook.id, userData.email);
            if (access.length === 0) {
                renderAlert("Access of the Workbook has been revoked, redirecting to My Workbooks","error",2000);
                dispatch(updateSharedWbInStoreIfWbDeleted(currentSelectedWorkbook.id, navigate, true));
                return false;
            }
        }
    
        else if (isShared) {
            const access = await getDocumentAccess(currentSelectedSheet.id, userData.email);
            if (access.length === 0) {
                renderAlert("Access of the Sheet has been revoked, redirecting to My Workbooks","error",2000);
                dispatch(updateSharedSheetInStore(currentSelectedSheet.id, navigate, true));
                return false;
            }
        }

        return true;

    } catch (e) {
        console.log("Error in checking access", e)
    }
}

const getPayload = (sheet, user, gridChangesPerSaveSession, isEmailAutomationEnabled, currentSelectedSheet) => ({
    sheetId: sheet,
    user,
    gridChangesPerSaveSession,
    isEmailAutomationEnabled,
    metaData: localStorage.getItem('mD_' + sheet) || JSON.stringify({
        name: currentSelectedSheet.name,
        sheetOwner: currentSelectedSheet.user_email
    })
});

const sendData = (url, payload) => {
    const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    const success = navigator.sendBeacon(url, blob);

    if (!success) {
        console.error("sendBeacon failed to send the request.");
    }
};

const handleRollupList = (currentSelectedSheet, sheetAccess, payload) => {
    if (sheetAccess?.Write) {
        payload.isSheetRolluplist = true;
    }
    sendData('/file/formatSheetToShareableList', {
        sheet_id: currentSelectedSheet.id,
        sheet_name: currentSelectedSheet.name
    });
};
export const saveDataBeforeUnload = async ({ rows, sheet, clearLocalStorage, gridChangesPerSaveSession, isEmailAutomationEnabled, sheetAccess }) => {
    try {
        const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer;
        const { myCurrentSession } = store.getState().userReducer;

        if (sheetAccess?.Read) {
            if (sheetAccess.Read.rows) {
                return sendData(`${ELASTIC_URL}/sheet/onlyUpdateRanges`, {
                    sheetId: sheet,
                    sheetIdentifier: currentSelectedSheet.sheet_identifier,
                    sheetDocObj,
                    partialRows: sheetAccess.Read.rows
                });
            }
        }

        if (!rows?.length || !isThereDataToBeSaved(gridChangesPerSaveSession)) {
            return;
        }

        let payload = getPayload(sheet, myCurrentSession, gridChangesPerSaveSession, isEmailAutomationEnabled, currentSelectedSheet);

        if (currentSelectedSheet?.sheetType === 'rolluplist') {
            handleRollupList(currentSelectedSheet, sheetAccess, payload);
        }

        sendData(`${ELASTIC_URL}/sheet/sendClientRowsToDB`, payload);

        if (clearLocalStorage) {
            localStorage.removeItem(sheet);
        }
    } catch (error) {
        console.error("Error in saveDataBeforeUnload", error);
    }
};
export const sendClientRowsToDB = async ({
    rows,
    sheet,
    clearLocalStorage,
    gridChangesPerSaveSession,
    isEmailAutomationEnabled,
    sheetAccess,
    callback,
    isButtonCall,
    isOnUnload,
    dispatch
}) => {
    const span = tracer.startSpan('sendClientRowsToDB');
    let functionFlow = ["sendClientRowsToDB started"]
    try {
        const { sheetDocObj, currentSelectedSheet } = store.getState().sheetReducer;
        const { myCurrentSession } = store.getState().userReducer;
        
        if (sheetAccess?.Read && sheetAccess.Read?.rows) {
            functionFlow.push("sheetAccess has Read access, handling read-only case");
            return await handleReadAccess(sheet, currentSelectedSheet, sheetDocObj, sheetAccess, rows);
        }

        if (!rows || rows.length === 0 || !isThereDataToBeSaved(gridChangesPerSaveSession)) {
            functionFlow.push("No rows to save or no data to be saved");
            return callback?.(null, true);
        }
        functionFlow.push("createPayloadForSendClientRowsToDB called");
        const payload = createPayloadForSendClientRowsToDB(sheet, rows, myCurrentSession, gridChangesPerSaveSession, isEmailAutomationEnabled, isOnUnload, currentSelectedSheet);
        
        functionFlow.push("saveRowsToDatabase called");
        const response = await saveRowsToDatabase(payload, sheet, clearLocalStorage, dispatch);
        
        logSpan('sendClientRowsToDB-api-response', span.spanContext(), "INFO", response);
        
        functionFlow.push("handleResponse called");
        handleResponse(response, currentSelectedSheet, callback, isButtonCall, span);
        
        functionFlow.push("sendClientRowsToDB end of try");
    } catch (error) {
        
        logSpan('sendClientRowsToDB-error', span.spanContext(), "ERROR", error);
        functionFlow.push("sendClientRowsToDB error");
        console.error(" Error in sendClientRowsToDB in currentsheetDataAction", error);
    } finally {
        functionFlow.push("sendClientRowsToDB end");
        span.setAttribute("sendClientRowsToDB-functionFlow", functionFlow);
        span.end();
    }
}

export const checkIfSessionInactive = (callback, isSharedWorkbook, navigate, selectSheet) => async (dispatch) => {
    try {
        const { myCurrentSession } = store.getState().userReducer;
        const { currentSelectedSheet } = store.getState().sheetReducer;
        const { currentSelectedWorkbook } = store.getState().workbookReducer;

        let result = await POST(`${ELASTIC_URL}/sheet/checkIfSessionInactive`, { sheetId: currentSelectedSheet.id, user: myCurrentSession });
        if (result.data === "Session is not latest") {
            return callback?.(result);
        }
        if (result.data === "Sheet is deleted") {
            dispatch(ifSheetDoesDeletedThenNavigate(currentSelectedSheet, currentSelectedWorkbook, isSharedWorkbook, navigate,
                selectSheet))
        }


    } catch (error) {
        console.error('Error in checkIfSessionInactive', error);

    }
}

const handleReadAccess = async (sheet, currentSelectedSheet, sheetDocObj, sheetAccess, rows) => {
    try {
        
        if (sheetAccess.Read?.rows) {
            await POST(`${ELASTIC_URL}/sheet/onlyUpdateRanges`, {
                sheetId: sheet,
                sheetIdentifier: currentSelectedSheet.sheet_identifier,
                rows: JSON.stringify(rows),
                sheetDocObj,
                partialRows: sheetAccess.Read.rows
            });
        }
    } catch (error) {
        console.error("Error in handleReadAccess", error);
        
    }
};

const createPayloadForSendClientRowsToDB = (sheet, rows, user, gridChangesPerSaveSession, isEmailAutomationEnabled, isOnUnload, currentSelectedSheet) => {
   try {
     let payload = {
         sheetId: sheet,
         rows: JSON.stringify(rows),
         user,
         gridChangesPerSaveSession,
         isEmailAutomationEnabled,
         metaData: localStorage.getItem('mD_' + sheet) || JSON.stringify({
             name: currentSelectedSheet.name,
             sheetOwner: currentSelectedSheet.user_email
         })
     };
 
     if (currentSelectedSheet?.sheetType === 'rolluplist') {
         payload.isSheetRolluplist = true;
     }
     if (isOnUnload) {
         payload.isOnUnload = true;
     }
 
     return payload;
   } catch (error) {
    console.error("Error in createPayloadForSendClientRowsToDB", error);
    
   }
};

const saveRowsToDatabase = async (payload, sheet, clearLocalStorage, dispatch) => {
    try {
        const response = await POST(`${ELASTIC_URL}/sheet/sendClientRowsToDB`, payload);
        if (clearLocalStorage && response?.data) {
            localStorage.removeItem(sheet);
        }
    dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: response?.data?.updatedDate || '' })
        return response;
    } catch (error) {
        console.error(error);
    }
};

const handleResponse = (response, currentSelectedSheet, callback, isButtonCall, span) => {
    let functionFlow = ["handleResponse started"];
    try {
        if (!response) {
            renderAlert("Delta rows failed : No response, please try to save again", "error")
            return
        };
    
        const { data } = response;
        const sheetName = currentSelectedSheet.name;
    
        if (data === 'Sheet is deleted') {
            functionFlow.push(`handleResponse sheet is deleted ${sheetName ?? "default"}`);
            return renderAlert(`Sheet ${sheetName} is deleted`, 'error');
        }
        if (data === "Error in Saving") {
            functionFlow.push(`handleResponse error in saving ${sheetName ?? "default"}`);
            return renderAlert("Sorry. We could not save your progress. Refresh or try again later.", "error");
        }
        if (data === "Session is not latest") {
            functionFlow.push(`handleResponse session is not latest ${sheetName ?? "default"}`);
            return callback?.(response);
        }
        if (hasDeltaErrors(data)) {
            functionFlow.push(`handleResponse ${sheetName ?? "default"} has delta errors`);
            return renderAlert(`Sheet - ${sheetName} Delta Rows Failed`, "error", 10000);
        }
        if (isRowSequenceDisturbed(data)) {
            functionFlow.push(`handleResponse ${sheetName ?? "default"} row sequence is disturbed`);
            return renderAlert(`Sheet - ${sheetName} Row Sequence Disturbed`, "error", 10000);
        }
        
        callback?.(response);
        if (isButtonCall) {
            functionFlow.push(`handleResponse isButtonCall ${sheetName ?? "default"} saved successfully`);
            renderAlert(`Sheet - ${sheetName} Saved`, "success", 3000);
        }
        functionFlow.push('handleResponse end of try')
    } catch (error) {
        functionFlow.push('handleResponse error')
        
        logSpan('sendClientRowsToDB-handleResponse-error', "ERROR", error);
        console.error(error);
    } finally {
        functionFlow.push('handleResponse finally')
        span.setAttribute('handleResponse-functionFlow', functionFlow);
    }
};

const hasDeltaErrors = (data) => {
    if(data) return ['add', 'update', 'delete', 'repeatedRows'].some(key => Object.hasOwn(data, key));
};

const isRowSequenceDisturbed = (data) => {
    if(data) return ['orderChange'].some(key => Object.hasOwn(data, key));
}


export const uploadAttachmentsToSheet = async () => {
    // let response = await POST(`${ELASTIC_URL}/sheet/uploadAttachmentsToSheet`, formData)
}
export const updateSheet = (sheetId, globalStyle) => async (dispatch) => {
    try {
        let response = await POST(`${ELASTIC_URL}/sheet/update`, { sheetId: sheetId, doc: { globalStyle } })
        dispatch({ type: ACTION_TYPES.SET_GLOBAL_STYLE, payload: globalStyle })
    }
    catch (e) {
        console.error("Error in updating sheet", e)
    }
}

export const updateEmailAutomationAction = (sheetId, isEmailAutomationEnabled) => async (dispatch) => {
    try {
        await POST(`${ELASTIC_URL}/sheet/update`, { sheetId, doc: { isEmailAutomationEnabled } })
        const { currentSelectedSheet } = store.getState().sheetReducer;
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: { ...currentSelectedSheet, isEmailAutomationEnabled } });
    } catch (e) {
        console.error("Error in updating email automation", e)
        const { currentSelectedSheet } = store.getState().sheetReducer;
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: { ...currentSelectedSheet, isEmailAutomationEnabled: !isEmailAutomationEnabled } });
    }
}

export const updateNamedFiltersAction = (sheetId,filterMapping) => async(dispatch)=> {
    try{   
        let filterMappingForSavingInDb = filterMapping.map(item => {
            return {
                ...item,
                filters: JSON.stringify(item.filters) 
            };
        });
        let response = await POST(`${ELASTIC_URL}/sheet/update`, { sheetId: sheetId, doc: { namedFilters:filterMappingForSavingInDb } })

        dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, namedFilters : filterMapping  });

    }catch (e) {
        console.log('Error while creating/updating nameFilter ', e);
        
    }
}


